import { render } from "./AiDashboardApp.vue?vue&type=template&id=22846fb4&scoped=true"
import script from "./AiDashboardApp.vue?vue&type=script&lang=js"
export * from "./AiDashboardApp.vue?vue&type=script&lang=js"

import "./AiDashboardApp.vue?vue&type=style&index=0&id=22846fb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22846fb4"]])

export default __exports__